import { apiSlice } from "../apiSlice";
interface TagItem {
  tag: string;
  show: boolean;
}

interface TagGroup {
  allowMultipleSelect: boolean;
  tags: TagItem[];
}

interface FilterTags {
  [category: string]: TagGroup;
}

interface GetRestaurantResponse {
  displayName: string;
  id: any;
  location: {
    latitude: number;
    longitude: number;
  };
  imageUrl: string;
  openingTime: string;
  closingTime: string;
  filterTags: FilterTags;
  deliverySettings?: {
    isFreeDelivery: boolean;
    perItemDeliveryFee: number;
  };
  maxDaysToScheduleAhead?: number;
  deliveryTimeSlots?: any[];
  holiday?: {
    date: {
      _seconds: number;
      _nanoseconds: number;
    };
    isFullDay: boolean;
    reason: string;
    openTime?: {
      _seconds: number;
      _nanoseconds: number;
    };
    closeTime?: {
      _seconds: number;
      _nanoseconds: number;
    };
  }[];
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const RestaurantService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRestaurantById: builder.mutation<GetRestaurantResponse, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getrestaurantbyid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getRestaurantFilterTagsById: builder.mutation<GetRestaurantResponse, string>(
      {
        query: (restaurantId) => ({
          url: `https://userhttps-getrestaurantfiltertags-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          keepUnusedDataFor: 300,
        }),
      }
    ),
  }),
});

export const {
  useGetRestaurantByIdMutation,
  useGetRestaurantFilterTagsByIdMutation,
} = RestaurantService;
